/* eslint-disable */
export default {
    init() {
        // JavaScript to be fired on the ACT Registration page
        $(() => {
            $('.gform_save_link').remove();
        });
    },
    finalize() {
        // JavaScript to be fired on the ACT Registration page, after the init JS
        $(document).ajaxComplete(function(event,request, settings){
          let actionUrl = new URLSearchParams(settings.data);
          if (actionUrl.get('action') === 'gpnf_refresh_markup') {
            let url = new URLSearchParams(window.location.search);
            let resume_token = url.get('gf_token');
            
            let attendeeEntries = [];
            window.GPNestedForms_22_4.entries.forEach(function (item, index) {
              attendeeEntries.push(item['id']);
            });
            
            let input_values = {
              'input_3': $("#input_22_3").val(),  // order_id
              'input_5': $("#input_22_5").val(),  // primary_email
              'input_6': $("#input_22_6").val(),  // act_event
              'input_4': attendeeEntries,         // attendees
              'resume_token': resume_token        // gf_token
            };

            updateAttendees( act_registration.ajaxUrl, act_registration.nonce, 'update_attendees', input_values );
          }
        });

        function updateAttendees(url, security, action, input_values) {

          const $promise = $.ajax({
            url: url,
            method: 'post',
            dataType: 'json',
            data: {'input_values': input_values, 'security': security, 'action': action }
          });

          $promise.done((response, textStatus, jqXhr) => {
            console.log('AJAX RESPONSE: ', response.data);
          });

          $promise.fail((jqXhr, textStatus, errorThrown) => {
            console.log(jqXhr);
            console.log(textStatus);
            console.log(errorThrown);
          });
        };
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/pageRegisterData.js